import React from "react";
import { MessageCircleIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { PagePreviewSlot } from "./PagePreviewSlot";
import { interiorPages, problemQuestions, problemStories } from "../data/landing";
export function ProblemSection() {
  return <section className="bg-white" data-id="element-219" data-mp="2vqhdk4dn1dw6">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-220" data-mp="2vpg3o38cyxg1">
        <SectionHeading eyebrow="Beyond Traditional Sunday School" title={<>
              Knowing Bible Stories Isn't the Same as Knowing{" "}
              <span className="text-royal" data-id="element-222" data-mp="35fixu6r7uhfy">WHY You Believe.</span>
            </>} data-id="element-221" data-mp="39hw2ssy52bbo" />

        <div className="mt-12 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-223" data-mp="3jf0okro2o4ry">
          <div className="space-y-2 text-center text-lg leading-relaxed text-ink-soft lg:text-left" data-id="element-224" data-mp="3egpf4i1ovwa9">
            {problemStories.map(line => <p key={line} data-id="element-225" data-mp="1p2klu0uhj8ru">{line}</p>)}
            <p className="pt-3 font-display text-xl font-bold text-ink" data-id="element-226" data-mp="1k2xwit1du22o">But what happens when someone asks:</p>
          </div>

          <ul className="grid gap-3 sm:grid-cols-2" data-id="element-227" data-mp="jdn35y242o2a">
            {problemQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-2xl rounded-bl-md bg-royal-light p-5" data-id="element-228" data-mp="obyg4hnpdeoq">
                <MessageCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-royal" aria-hidden="true" data-id="element-229" data-mp="se1q11uq4b7w" />
                <span className="font-display text-lg font-bold leading-snug text-navy" data-id="element-230" data-mp="x51q2fz539em">“{q}”</span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-lg leading-relaxed text-ink-soft" data-id="element-231" data-mp="123cziplivhwb">
          <p data-id="element-232" data-mp="174sm4m3clwgt">These are the kinds of questions that can leave even dedicated Christian families searching for answers.</p>
          <p data-id="element-233" data-mp="1g3dyfzi88f95">
            Memorizing the stories is valuable. But understanding the reasons behind Christian beliefs requires
            something more.
          </p>
          <p className="font-display text-xl font-bold text-ink" data-id="element-234" data-mp="3duyro2zi80vm">
            WHY WE BELIEVE was created to help families take that next step.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6" data-id="element-235" data-mp="p1bonq0w4uq8">
          {interiorPages.map(page => <PagePreviewSlot key={page.detail} src={page.src} label={page.label} detail={page.detail} data-id="element-236" data-mp="k2h8ywy7zmac" />)}
          <div className="flex aspect-[4/5] flex-col items-center justify-center rounded-2xl bg-navy p-4 text-center" data-id="element-237" data-mp="y1qgz9c9va38">
            <p className="font-display text-2xl font-extrabold text-white md:text-3xl" data-id="element-238" data-mp="ty288nbwm8ge">
              And much <span className="text-gold" data-id="element-239" data-mp="17xa4p8gon2gw">more…</span>
            </p>
            <p className="mt-2 text-sm text-white/75" data-id="element-240" data-mp="12z08qvn4vxu8">52 guided lessons across 6 volumes</p>
          </div>
        </div>
      </div>
    </section>;
}